import { schema } from 'normalizr'

const takeoutRestaurant = new schema.Entity('takeoutRestaurants')

export default takeoutRestaurant
